import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconPhone"><Path fillRule="evenodd" clipRule="evenodd" d="M5 3.75C5 2.23122 6.23122 1 7.75 1H16.25C17.7688 1 19 2.23122 19 3.75V20.25C19 21.7688 17.7688 23 16.25 23H7.75C6.23122 23 5 21.7688 5 20.25V3.75ZM9.75 18.5C9.33579 18.5 9 18.8358 9 19.25C9 19.6642 9.33579 20 9.75 20H14.25C14.6642 20 15 19.6642 15 19.25C15 18.8358 14.6642 18.5 14.25 18.5H9.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPhone;
